import { Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Dimensions from 'ContentComponents/cmv2/media/Dimensions';
import SizingOptions from 'ContentComponents/cmv2/media/SizingOptions';
import { calcDimensionsHeight, calcDimensionsWidth } from 'ContentComponents/cmv2/media/mediaHelpers';
import MediaSizeTypes from 'ContentUtils/constants/MediaSizeTypes';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.image.${key}`;
class ImageSizing extends Component {
  constructor(props) {
    super(props);
    this.getDimensionProps = () => {
      const {
        fieldKey,
        value
      } = this.props;
      const {
        height,
        max_height,
        max_width,
        size_type,
        width
      } = value || {};
      let renderedWidth = width;
      let renderedHeight = height;
      let heightLabel = i18nKey('sizing.sizeType.heightLabel');
      let heightKey = 'height';
      let widthLabel = i18nKey('sizing.sizeType.widthLabel');
      let widthKey = 'width';
      if (size_type === MediaSizeTypes.AUTO_CUSTOM_MAX) {
        renderedHeight = max_height && max_height > 0 ? max_height : height;
        renderedWidth = max_width && max_width > 0 ? max_width : width;
        heightLabel = i18nKey('sizing.maxSizeType.heightLabel');
        heightKey = 'maxHeight';
        widthLabel = i18nKey('sizing.maxSizeType.widthLabel');
        widthKey = 'maxWidth';
      }
      return {
        height: renderedHeight,
        heightLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: heightLabel
        }),
        heightSeleniumKey: `${fieldKey}:${heightKey}`,
        width: renderedWidth,
        widthLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: widthLabel
        }),
        widthSeleniumKey: `${fieldKey}:${widthKey}`
      };
    };
    this.getMaxDimensionProps = () => {
      const {
        aspectRatio,
        maxContainerWidth,
        responsiveEnabled
      } = this.props;
      let maxDimensionProps = {};
      if (!responsiveEnabled && maxContainerWidth) {
        const maxHeight = Math.round(maxContainerWidth * 1 / aspectRatio);
        maxDimensionProps = {
          maxHeight,
          maxWidth: maxContainerWidth
        };
      }
      return maxDimensionProps;
    };
    this.onDimensionChange = this.onDimensionChange.bind(this);
    this.onSizeTypeChange = this.onSizeTypeChange.bind(this);
  }
  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps, null);
  }
  get isResponsiveSizing() {
    const {
      value
    } = this.props;
    const {
      size_type
    } = value || {};
    return size_type === MediaSizeTypes.AUTO || size_type === MediaSizeTypes.AUTO_CUSTOM_MAX;
  }
  onDimensionChange(e, calcDimensions, dimensionsLoggerLabel) {
    const {
      aspectRatio,
      dimensionsLogger,
      onFieldChange,
      responsiveEnabled,
      value
    } = this.props;
    const {
      size_type
    } = value || {};
    const dimensionValue = e.target.value;
    const isMax = size_type === MediaSizeTypes.AUTO_CUSTOM_MAX;
    if (isMax && !responsiveEnabled) return;
    const dimensions = calcDimensions(dimensionValue, aspectRatio, isMax);
    if (dimensions) {
      if (typeof dimensionsLogger === 'function') {
        dimensionsLogger(dimensions || {}, dimensionsLoggerLabel);
      }
      onFieldChange(Object.assign({}, value, dimensions));
    }
  }
  onSizeTypeChange(e) {
    const {
      onFieldChange,
      value
    } = this.props;
    onFieldChange(Object.assign({}, value, {
      size_type: e.target.value
    }));
  }
  renderDimensions() {
    const {
      readOnly,
      resizable,
      useOnDark
    } = this.props;
    if (!resizable) return null;
    return /*#__PURE__*/_jsx(Dimensions, Object.assign({
      onHeightChange: e => this.onDimensionChange(e, calcDimensionsHeight, 'onHeightChange'),
      onWidthChange: e => this.onDimensionChange(e, calcDimensionsWidth, 'onWidthChange'),
      readOnly: readOnly,
      useOnDark: useOnDark
    }, this.getDimensionProps(), this.getMaxDimensionProps()));
  }
  renderResponsiveSizing() {
    const {
      fieldKey,
      readOnly,
      responsiveEnabled,
      useOnDark,
      value
    } = this.props;
    const {
      size_type
    } = value || {};
    return /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "400",
      as: "div",
      children: [/*#__PURE__*/_jsx(SizingOptions, {
        fieldKey: fieldKey,
        exactTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('sizing.sizeType.options.exactTooltip')
        }),
        isExactSizingEnabled: true,
        isFullWidthSizingEnabled: false,
        onChange: this.onSizeTypeChange,
        originalSizeOption: unescapedText(i18nKey('sizing.maxSizeType.options.original')),
        readOnly: readOnly || !responsiveEnabled,
        responsiveTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('sizing.sizeType.options.autoTooltip')
        }),
        showResponsiveSizingAlert: !responsiveEnabled && this.isResponsiveSizing,
        sizeType: size_type,
        useOnDark: useOnDark
      }), (!size_type || size_type === MediaSizeTypes.EXACT || size_type === MediaSizeTypes.AUTO_CUSTOM_MAX) && this.renderDimensions()]
    });
  }
  render() {
    const {
      resizable,
      responsiveEnabled
    } = this.props;
    if (!resizable) {
      return null;
    }
    if (responsiveEnabled || this.isResponsiveSizing) {
      return this.renderResponsiveSizing();
    }
    return this.renderDimensions();
  }
}
ImageSizing.defaultProps = {
  resizable: true,
  value: {}
};
export default ImageSizing;